import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { environment } from "@env/environment";
import {
  AuthGuard,
  ExitConfirmationGuard,
  accountSetupCanActivate,
  userOnboardingCanActivate,
  userOnboardingEntryCanActivate,
  sessionRedirectCanActivate,
} from "@core";
import { authSimpleCanActivate } from "@delon/auth";
// layout
import { LayoutDefaultComponent } from "@layout";
import { CertificatesComponent } from "./provisioning/certificates/certificates.component";

const routes: Routes = [
  { path: "", redirectTo: "confirm/certificate", pathMatch: "full" },
  {
    path: "get-started",
    canActivate: [AuthGuard, userOnboardingEntryCanActivate],
    loadChildren: () =>
      import("./user-onboarding/user-onboarding.module").then(
        (m) => m.UserOnboardingModule
      ),
  },
  {
    path: "certificates",
    component: LayoutDefaultComponent,
    canActivate: [authSimpleCanActivate, userOnboardingCanActivate],
    data: {
      title: "My Certificate",
      titleI18n: "PAGE_TITLES.CERTIFICATE",
    },
    children: [
      {
        path: "",
        canDeactivate: [ExitConfirmationGuard],
        component: CertificatesComponent,
        data: {
          title: "Certificates",
          titleI18n: "PAGE_TITLES.CERTIFICATE",
        },
      },
      {
        path: "preview/:id",
        component: CertificatesComponent,
        data: {
          title: " Certificates",
          titleI18n: "PAGE_TITLES.CERTIFICATE",
        },
      },
    ],
  },

  {
    path: "confirm",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./confirmation/confirmation.module").then(
        (m) => m.ConfirmationModule
      ),
  },
  {
    path: "certificate",
    loadChildren: () =>
      import("./preview-certificate/preview-certificate.module").then(
        (m) => m.PreviewCertificateModule
      ),
  },

  {
    // Public share link: reachable without login, so no auth/setup guard.
    path: "certificate/share",
    loadChildren: () =>
      import(
        "./shared-certificate-preview/shared-certificate-preview.module"
      ).then((m) => m.SharedCertificatePreviewModule),
  },

  {
    path: "public",
    loadChildren: () =>
      import("./public/public.module").then((m) => m.PublicModule),
  },

  {
    path: "access",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./provisioning/provisioning.module").then(
        (m) => m.ProvisioningModule
      ),
  },
  // ACCOUNT & BILLING
  {
    // Shared by candidates and verifiers: neither may enter until their own
    // setup (USER: exam country, VERIFIER: onboarding) is complete.
    path: "profile",
    canActivate: [AuthGuard, accountSetupCanActivate],
    loadChildren: () =>
      import("./profile/profile.module").then((m) => m.ProfileModule),
  },
  {
    path: "notifications",
    canActivate: [AuthGuard, userOnboardingCanActivate],
    loadChildren: () =>
      import("./notifications/notifications.module").then(
        (m) => m.NotificationsModule
      ),
  },
  {
    // Shared by candidates and verifiers: neither may enter until their own
    // setup (USER: exam country, VERIFIER: onboarding) is complete.
    path: "billing",
    canActivate: [AuthGuard, accountSetupCanActivate],
    loadChildren: () =>
      import("./billing/billing.module").then((m) => m.BillingModule),
  },
  {
    path: "enquiry",
    canActivate: [AuthGuard, userOnboardingCanActivate],
    loadChildren: () =>
      import("./enquiry/enquiry.module").then((m) => m.EnquiryModule),
  },
  // Authentication
  {
    path: "account",
    canActivate: [sessionRedirectCanActivate],
    loadChildren: () =>
      import("./passport/passport.module").then((m) => m.PassportModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./exception/exception.module").then((m) => m.ExceptionModule),
  },
  //{path: '*path', redirectTo: '/404'},
  { path: "**", redirectTo: "404" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      scrollPositionRestoration: "top",
    }),
  ],
  exports: [RouterModule],
})
export class RouteRoutingModule {}
